// src/lib/blog-types.ts
//
// Client-safe types and constants for the blog.
// This file has NO Node.js imports (no fs, no path) so it can be safely
// imported into client components without breaking edge runtime builds.

export type BlogCategory = 'Math' | 'Reading & Writing' | 'Strategy' | 'News' | 'Product'

export const BLOG_CATEGORIES: BlogCategory[] = [
  'Math',
  'Reading & Writing',
  'Strategy',
  'News',
  'Product',
]

export interface BlogFrontmatter {
  title: string
  date: string // ISO date string (YYYY-MM-DD)
  excerpt: string
  category: BlogCategory
  readingMinutes: number
  coverImage: string
  author: string
  /** Display name of the series this post belongs to (e.g. "Desmos on the
   *  Digital SAT"). Optional — most posts are standalone. */
  series?: string
  /** 1-based position within the series. Only meaningful with `series`. */
  seriesPart?: number
  /** ISO date (YYYY-MM-DD) of the latest editorial review — distinct from the
   *  publication `date`. Optional; shown on the article and used as JSON-LD
   *  dateModified so search engines see content freshness. */
  lastReviewed?: string
}

export interface BlogPostMeta extends BlogFrontmatter {
  slug: string
}

export interface BlogPost extends BlogPostMeta {
  content: string
}

/** Format a blog date string (YYYY-MM-DD) into "Month D, YYYY". */
export function formatBlogDate(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleDateString('en-US', {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}
